<template>
  <v-app>
    <Header2></Header2>
    <v-main>
      <div :class="fondo">
        <router-view />
      </div>
    </v-main>
    <Footer2></Footer2>
  </v-app>
</template>

<script>
// import Header from "@/layouts/Header.vue";
import Header2 from "@/layouts/Header2.vue";
// import Footer from "@/layouts/Footer.vue";
import Footer2 from "@/layouts/Footer2.vue";
import { mapState, mapMutations } from "vuex";

export default {
  name: "App",
  computed: {
    ...mapState(["theme", "mobile", "hideItem", "loading", "idTrack"]),
  },
  components: {
    // Header,
    Header2,
    // Footer,
    Footer2,
  },
  data() {
    return {
      fondo: "background",
    };
  },

  watch: {
    theme() {
      if (this.theme == "dark") {
        this.fondo = "background2";
        this.$vuetify.theme.dark = true;
        localStorage.setItem("theme", "dark");
      } else if (this.theme == "light") {
        this.fondo = "background";
        this.$vuetify.theme.dark = false;
        localStorage.setItem("theme", "light");
      }
    },
    loading: function () {
      if (this.loading == true) {
        setTimeout(() => {
          if (this.loading == true && this.idTrack == null) {
            this.setLoading(false);
          }
        }, 2000);
      }
    },

    // windowX: function () {
    // 	if (this.windowX < 960) {
    // 		this.setHide(true);
    // 		if (this.windowX < 600) {
    // 			this.setMobile(true);
    // 		} else if (this.windowX >= 600) {
    // 			this.setMobile(false);
    // 		}
    // 	} else if (this.windowX >= 960) {
    // 		this.setHide(false);
    // 	}
    // },
  },
  created() {
    let x = localStorage.getItem("theme");
    //console.log(x);
    if (x != null) {
      this.setTheme(x);
    } else if (x == null) {
      localStorage.setItem("theme", "light");
      this.setTheme("ligth");
    }
  },
  methods: {
    ...mapMutations(["setTheme", "setHide", "setMobile", "setLoading"]),
  },
};
</script>

<style>
.background {
  background: rgb(183, 183, 183);
  /* background: rgb(103, 103, 103); */
  /* background: linear-gradient(
    180deg,
    rgba(103, 103, 103, 1) 0%,
    rgba(255, 247, 247, 1) 100%
  ); */

  height: 100%;
}

.background2 {
  background: rgb(103, 103, 103);
  /* background: rgb(173, 173, 173); */
  /* background: linear-gradient(
    180deg,
    rgba(173, 173, 173, 1) 0%,
    rgba(135, 135, 135, 1) 31%,
    rgba(77, 77, 77, 1) 100%
  ); */

  height: 100%;
}

.tWhite {
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 15px;
}

.azul {
  color: #236192;
}

.tBlack {
  background-color: rgba(0, 0, 0, 0.25);
  border-radius: 15px;
}

.titulo {
  font-size: 40px;
  color: rgb(121, 121, 121);
}

.titulo2 {
  font-size: 30px;
  color: rgb(121, 121, 121);
}

.titulo3 {
  font-size: 22px;
  color: rgb(121, 121, 121);
}

.textStandby {
  color: rgb(199, 198, 198);
  font-size: 18px;
}

.textSuccess {
  color: rgb(8, 255, 70);
  font-size: 18px;
}

.textError {
  color: rgb(255, 86, 86);
  font-size: 18px;
}

.changeZoom {
  zoom: 75%;
}

.my-background {
  background-image: url("assets/fondo-appbarr.jpg");
  /**/
  background-size: cover;
  /* Ajusta la imagen al tamaño del v-card */
  background-repeat: no-repeat;
  /* Evita que la imagen se repita */
  background-position: center center;
  /* Centra la imagen */
  opacity: 0.7;
}
</style>
